(function () {
  'use strict';

  angular
    .module('trainingAllowanceReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('trainingAllowanceReport', {
        url: '/training-allowance-report',
        views: {
          'trainingAllowanceReportView': {
          templateUrl: 'training-allowance-report/views/training-allowance-report.tpl.html',
          controller: 'TrainingAllowanceReportCtrl',
          controllerAs: 'trainingAllowanceReport'
        }
        }
      });
  }
}());
